import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './helpers'
import './filters'
import './permission_codes'
import './registerServiceWorker'

import html2pdf from 'html2pdf.js'
Vue.prototype.$html2pdf = html2pdf

//axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// Add a request interceptor
axios.interceptors.request.use(function (config) {
	store.commit('fetching_data')
	return config;
}, function (error) {
	store.commit('done_fetching')
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
	store.commit('done_fetching')
	return response;
}, function (error) {
	store.commit('done_fetching')
	if (error.response){
		if (error.response.status === 401) {    
			router.push('/login')
		}
	}	
	return Promise.reject(error);
});

//bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

//font awesome
import "font-awesome/css/font-awesome.min.css";
Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default)

//papa parse https://www.npmjs.com/package/vue-papa-parse
import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

//https://www.digitalocean.com/community/tutorials/vuejs-vue-workers
import VueWorker from 'vue-worker'
Vue.use(VueWorker);

// base urls with proxies appended
// var proxy_server = 'http://127.0.0.1:8000/proxy/'
Vue.prototype.$version = 'v1'

Vue.prototype.$API_BASE_URL =  'https://api.vidduka.com'

Vue.config.productionTip = false
new Vue({
  router,
  store,  
  render: h => h(App)
}).$mount('#app')
